import { render, staticRenderFns } from "./TemplateSelection.vue?vue&type=template&id=acd0f1aa&scoped=true&"
import script from "./TemplateSelection.vue?vue&type=script&lang=js&"
export * from "./TemplateSelection.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSelection.vue?vue&type=style&index=0&id=acd0f1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd0f1aa",
  null
  
)

export default component.exports